import { Component } from '@theme/component';
import { klaviyoTargetFor, subscribeToKlaviyo } from './klaviyo-subscribe.js';

/**
 * Newsletter signup on the vouchers page. Submits to Klaviyo only (the ESP). The surrounding
 * Shopify customer form is the no-JS fallback; it carries data-nocaptcha="true" because Shopify's
 * captcha script otherwise re-submits customer forms natively, ignoring preventDefault().
 */
class VouchersNewsletterComponent extends Component {
  requiredRefs = ['email', 'firstName', 'submitButton', 'status'];

  // Liquid's {% form %} tag can't emit an `on:submit` attribute (the colon is not a valid
  // argument name), so the submit listener is attached here instead.
  connectedCallback() {
    super.connectedCallback();
    this.querySelector('form')?.addEventListener('submit', this.submit);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.querySelector('form')?.removeEventListener('submit', this.submit);
  }

  /** @param {Event} event */
  submit = async (event) => {
    event.preventDefault();

    const form = event.target;
    const { email, firstName, submitButton, status } = this.refs;

    if (
      !(form instanceof HTMLFormElement) ||
      !(email instanceof HTMLInputElement) ||
      !(firstName instanceof HTMLInputElement) ||
      !(submitButton instanceof HTMLButtonElement) ||
      !(status instanceof HTMLElement)
    ) {
      return;
    }

    const { listId, locale } = klaviyoTargetFor(this);

    submitButton.disabled = true;
    this.setAttribute('aria-busy', 'true');

    const ok = await subscribeToKlaviyo({
      email: email.value,
      firstName: firstName.value,
      listId,
      locale,
      source: 'Vouchers Page',
    });

    submitButton.disabled = false;
    this.removeAttribute('aria-busy');

    status.classList.toggle('vouchers-newsletter__status--error', !ok);
    // Clear first and fill on the next frame so repeated results are announced again.
    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = (ok ? status.dataset.success : status.dataset.error) ?? '';
    });

    if (!ok) return;

    form.reset();
    window.phCapture?.('vouchers_newsletter_subscribed', { locale });
  };
}

if (!customElements.get('vouchers-newsletter-component')) {
  customElements.define('vouchers-newsletter-component', VouchersNewsletterComponent);
}
